import styled from 'styled-components';
import Rocket from '../../../assets/images/pluvaAutoLanding/repair_emoji_rocket.png';
import HammerAndWrench from '../../../assets/images/pluvaAutoLanding/repair_emoji_hammer-and-wrench.png';
import Wireless from '../../../assets/images/pluvaAutoLanding/repair_emoji_wireless.png';
import Stethoscope from '../../../assets/images/pluvaAutoLanding/repair_emoji_stethoscope.png';
import Receipt from '../../../assets/images/pluvaAutoLanding/repair_emoji_receipt.png';
import { PointBadge } from './PointBadge';

interface IRepairSupportInfo {
  icon: string;
  serviceName: string;
  description: string;
}

const serviceDetails: IRepairSupportInfo[] = [
  {
    icon: Rocket,
    serviceName: '전국 방문 설치',
    description: '전국, 전지역! 무료 방문 설치!',
  },
  {
    icon: HammerAndWrench,
    serviceName: '2년 무상수리',
    description: '사용자 과실 제외, 무상 보증 수리',
  },
  {
    icon: Wireless,
    serviceName: '신기능 무상 업그레이드',
    description: '내장된 통신 장비로 무상 업그레이드',
  },
  {
    icon: Stethoscope,
    serviceName: '방문 전, 원격 진단 지원',
    description: '자사 전문 매니저의 원격 진단',
  },
  {
    icon: Receipt,
    serviceName: 'RTK-GPS와 LTE 비용 지원',
    description: '24년 구입 고객 5년간 무상 지원',
  },
];

const RepairSupportInfoCard = ({ serviceDetail }: { serviceDetail: IRepairSupportInfo }) => {
  const { icon, serviceName, description } = serviceDetail;
  return (
    <Card>
      <ImageWrapper>
        <Image src={icon} alt={`${serviceName}의 아이콘`} />
      </ImageWrapper>
      <ContentWrapper>
        <ServiceName>{serviceName}</ServiceName>
        <ServiceDescription>{description}</ServiceDescription>
      </ContentWrapper>
    </Card>
  );
};

export const RepairSupportInfoSection = () => {
  return (
    <Container>
      <TitleWrapper>
        <PointBadge title={'제품 보증'} />
        <Title>{'구입과 동시에 제공되는\n탄탄한 보증!'}</Title>
        <Description>{'전국의 대리점과 전문 AS팀이 보장하는수리,\n무선 통신으로 제공하는 업데이트 까지'}</Description>
      </TitleWrapper>
      <RepairSupportInfoCards>
        {serviceDetails.map((service) => {
          return <RepairSupportInfoCard key={service.serviceName} serviceDetail={service} />;
        })}
      </RepairSupportInfoCards>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  padding: 0px 24px 48px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;

  border-bottom: 1px solid var(--Light-Scheme-Monochrome-grey20, #e4e4ed);
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-large, 16px);
  align-self: stretch;
`;

const Title = styled.h2`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/XXX-Large/xxxl-bold */
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 31.2px */

  white-space: pre-line;
`;

const Description = styled.pre`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */

  white-space: pre-line;
`;

const RepairSupportInfoCards = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: var(--radius-large, 16px);
  align-self: stretch;
`;

const Card = styled.div`
  display: flex;
  padding: var(--radius-large, 16px) 24px;
  align-items: center;
  gap: var(--radius-large, 16px);
  align-self: stretch;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;

const ImageWrapper = styled.div`
  display: flex;
  width: 48px;
  min-width: 48px;
  height: 48px;
  padding: var(--radius-medium, 8px);
  justify-content: center;
  align-items: center;
  gap: 10px;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-white, #fff);
`;

const Image = styled.img`
  width: 24px;
  height: 24px;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  flex: 1 0 0;
`;

const ServiceName = styled.p`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Display/Large/l-medium */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 20.8px */
`;

const ServiceDescription = styled.p`
  color: var(--Light-Scheme-Monochrome-grey100, #858894);

  /* Display/Medium/m-regular */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 18.2px */
`;
